export default "__VITE_ASSET__9469408e__"